<template>
  <div class="base-tabs" :class="tabClasses">
    <ul class="tab-selection custom-scrollbar"
        role="tablist"
        v-if="!$props.hideTabs">
      <li v-for="(tab, index) in tabList"
          :key="`base-tab-${componentId}-${index}`"
          class="tab-single"
          role="tab">
        <a href="#"
           :class="{active: tab.name === selectedTab}"
           @click.prevent="selectTabOnClick(tab.name)">
          {{ tab.label }}
        </a>
      </li>
    </ul>
    <transition name="fade" mode="out-in">
      <div class="base-tab-page"
           ref="tabContainer"
           :style="{minHeight: containerHeight+'px'}">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  data () {
    return {
      tabs: [],
      containerHeight: 0,
      selectedTab: ''
    }
  },
  props: {
    value: {
      required: true,
      default: ''
    },
    type: {
      type: String,
      default: 'horizontal',
      validator: value => {
        const allowedTypes = ['horizontal', 'vertical']
        return allowedTypes.includes(value)
      }
    },
    hideTabs: Boolean
  },
  computed: {
    tabList () {
      return this.tabs
    },
    componentId () {
      return this._uid
    },
    tabClasses () {
      return {
        [`type-${this.$props.type}`]: this.$props.type
      }
    }
  },
  methods: {
    getContainerHeight () {
      this.containerHeight = this.$refs.tabContainer.getBoundingClientRect().height || 0

      setTimeout(() => {
        this.containerHeight = 0
      }, 300)
    },
    selectTab (tabName) {
      this.tabList.forEach(tab => {
        if (tabName === tab.name) {
          setTimeout(() => {
            tab.isActive = true
            this.$emit('tab-change', tabName)
          }, 300)
          this.getContainerHeight()
          this.selectedTab = tabName
        } else {
          tab.isActive = false
        }
      })
    },
    selectTabOnClick (name) {
      this.$emit('input', name)
    }
  },
  watch: {
    value (newVal) {
      this.selectTab(newVal)
    }
  },
  mounted () {
    this.tabs = this.$children
    if (this.tabs.length) {
      if (this.$props.value) {
        this.selectTab(this.$props.value)
      } else {
        this.selectTab(this.tabs[0].name)
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./tabs.scss"></style>
